import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter, FilterEnum } from '@app/models';
import { displayName } from '@app/helpers';

class VaultFoldersService {
    readonly apiBase: string = '/api/directory/Vaults';

    getVaultFolders(vaultId: string, orderBy: string, asc: string, top: number, skip: number, isReset: boolean, filter: string, passwordFilter: boolean, handleSuccess?: Function): AxiosPromise {

        let filters: IActiveFilter[] = [];
        if (filter !== '') {
            if (passwordFilter) {
                filters.push({
                    label: '',
                    name: FilterEnum.vaultPasswords,
                    value: filter,
                    filterBy: 'DisplayName'

                });
            }
            else {
                filters.push({
                    label: '',
                    name: FilterEnum.contains,
                    value: filter,
                    filterBy: 'DisplayName'
                });
            }
        }

        return apiService.get(`${this.apiBase}(${vaultId})/GetVaultFolderByVaultId`,
            {
                params: {
                    $orderBy: orderBy + ' ' + asc,
                    $top: top,
                    $skip: skip,
                    $count: isReset,
                    $filter: manageFilters(filters)
                },
                onSuccess: handleSuccess
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    async getAllVaultFolders(vaultId: string, asc: string, skip: number = 0, values: any[] = []): Promise<any[]> {
        const resp: AxiosResponse = await this.getVaultFolders(vaultId, displayName, asc, 100, skip,  true, '',   false);

        skip += resp.data.value.length;
        values = [...values, ...resp.data.value];

        if (skip < resp.data['@odata.count']) {
            return this.getAllVaultFolders(vaultId, asc, skip, values);
        } else {
            return values;
        }
    }

    deleteVaultFolders(ids: string[], vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/DeleteVaultFolder`,
            {
                'VaultFolder': ids
            },
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    }

    isVaultFolderNameAvailable(VaultFolder: object, vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/IsVaultFolderNameAvailable`,
            {
                VaultFolder
            },
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    }

    updateVaultFolder(VaultFolder: object, vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/UpdateVaultFolder`,
            {
                VaultFolder
            },
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    }

    addVaultFolder(VaultFolder: object, vaultId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${vaultId})/AddVaultFolder`,
            {
                VaultFolder
            },
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    }
}

export const vaultFoldersService = new VaultFoldersService();
